import { PortableText } from '@portabletext/react';
import { Link } from "react-router-dom";
import AnimateIn from '../general/AnimateIn';
import { useImages } from '../general/ImageProvider';
import { urlFor } from '../lib/imageUrl';
import HomeSlides from './Home-Slides';

const HomeHero = () => {
    const images = useImages();

    if (!Array.isArray(images) || !images.length) {
        return <div></div>;
    }

    // Helper function to find an image by title
    const getImageByTitle = (title) => {
        return images.find((image) => image.title === title);
    };

    // Fetch specific images by their titles
    
    const heroimg = getImageByTitle('Home Hero Section') || {};
    const secIcon = getImageByTitle('sec-icon') || {};
    const htmlImg = getImageByTitle('Html Formatter');
    const CSSImg = getImageByTitle('Html Formatter');
    const heictojpgImg = getImageByTitle('HEIC To JPG') || {};
    const pdftodocImg = getImageByTitle('PDF to DOC') || {};
    const pngtowebpImg = getImageByTitle('PNG to WEBP') || {};
    const jsImg = getImageByTitle('JS Formatter') || {};
    const covertImg = getImageByTitle('Case Converter') || {};

    return (
        <>
            <section className="pt-5">
                <div className="p-relative">
                    <div
                        className=""
                        style={{
                            position: 'absolute',
                            bottom: '240px',
                            width: '100%',
                            height: '700px',
                            backgroundImage: 'linear-gradient(90deg, #0a0c11, #0c1218, #0c171e, #0a1b23, #052027)',
                        }}
                    ></div>

                    <div className="container" style={{ position: 'relative' }}>
                        <div className="row p-4 justify-content-center">

                            <div className="col-lg-10 px-5 text-center">
                                <AnimateIn type=" up" >
                                    <div className="sec-title">
                                        <div className="px-2 d-flex align-items-center">
                                            <div>{heroimg.Sectitle}</div>
                                            <div className="px-2 sec-icon">
                                                {secIcon.file && (
                                                    <img
                                                        src={urlFor(secIcon.file.asset)}
                                                        alt={secIcon.altText}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="home-title pt-3">
                                        <span className="text-gradient">
                                            {heroimg.sectionTitle}
                                        </span>
                                    </div>
                                    <div className="section-content">
                                        {/* Render Portable Text content */}
                                        {heroimg.content && (
                                            <PortableText
                                                value={heroimg.content}
                                                components={{
                                                    block: {
                                                        normal: ({ children }) => <p>{children}</p>,
                                                        h1: ({ children }) => <h1>{children}</h1>,
                                                        h2: ({ children }) => <h2>{children}</h2>,
                                                    },
                                                    marks: {
                                                        link: ({ children, value }) => (
                                                            <a
                                                                href={value.href}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-blue-500"
                                                            >
                                                                {children}
                                                            </a>
                                                        ),
                                                    },
                                                }}
                                            />
                                        )}
                                    </div>
                                    {/* <Link to="text-gizmo" smooth={true} duration={500} className="panacea-arrow-link">
                                        {heroimg.btnlabel} <i className="bx bxs-right-top-arrow-circle"></i>
                                    </Link> */}
                                </AnimateIn>
                            </div>
                            {/*                           
                            <div className="py-5">
                                <Home-Slides />
                            </div> */}

                            {/* OverView Image Section */}
                            <div className="row my-5 align-items-center justify-content-center d-desktop">
                                <div className="col-md-2">
                                    <div className="overview-single-box">
                                      <Link to="code-gizmo/html-beautify" >
                                        {htmlImg && (

                                            <img
                                                src={urlFor(htmlImg.file.asset)}
                                                alt={htmlImg.altText || 'Sanity Image'}
                                                className="img-fluid" />

                                        )}
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="overview-multiple-box-well">
                                        <div className="overview-multiple-box" >
                                          <Link to="code-gizmo/js-beautify" >
                                            {jsImg && (

                                                <img
                                                    src={urlFor(jsImg.file.asset)}
                                                    alt={jsImg.altText || 'Sanity Image'}
                                                    className="img-fluid" />

                                            )}
                                            </Link>
                                        </div>
                                        <div className="overview-multiple-box multi-box-2 mt-3" >
                                            <Link to="text-gizmo/convert-case" >
                                       {covertImg && (

                                            <img
                                                src={urlFor(covertImg.file.asset)}
                                                alt={covertImg.altText || 'Sanity Image'}
                                                className="img-fluid" />

                                        )}
                                        </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="overview-single-box big-single-box">
                                        <Link to="code-gizmo/css-beautify" >
                                          {CSSImg && (

                                            <img
                                                src={urlFor(CSSImg.file.asset)}
                                                alt={CSSImg.altText || 'Sanity Image'}
                                                className="img-fluid" />

                                        )}
                                        </Link>
                                    </div>
                                </div>
                                   <div className="col-md-2">
                                    <div className="overview-multiple-box-well">
                                        <div className="overview-multiple-box" >
                                          <Link to="image-gizmo/heic-to-jpg" >
                                            {heictojpgImg && (

                                                <img
                                                    src={urlFor(heictojpgImg.file.asset)}
                                                    alt={heictojpgImg.altText || 'Sanity Image'}
                                                    className="img-fluid" />

                                            )}
                                            </Link>
                                        </div>
                                        <div className="overview-multiple-box multi-box-2 mt-3" >
                                            <Link to="social-automation" >
                                       {pdftodocImg && (

                                            <img
                                                src={urlFor(pdftodocImg.file.asset)}
                                                alt={pdftodocImg.altText || 'Sanity Image'}
                                                className="img-fluid" />

                                        )}
                                        </Link>
                                        </div>
                                    </div>
                                </div>
                                  <div className="col-md-2">
                                    <div className="overview-single-box">
                                      <Link to="image-gizmo/png-to-webp" >
                                        {pngtowebpImg && (

                                            <img
                                                src={urlFor(pngtowebpImg.file.asset)}
                                                alt={pngtowebpImg.altText || 'Sanity Image'}
                                                className="img-fluid" />

                                        )}
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <HomeSlides />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HomeHero;
